import { render, staticRenderFns } from "./DeliveryCosts.vue?vue&type=template&id=0eba0376&"
import script from "./DeliveryCosts.vue?vue&type=script&lang=js&"
export * from "./DeliveryCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports